/**
 * センサーに共通するヘルパー関数置き場
 */

/**
 * センサーデータからセンサーグループとセンサーの紐付けを情報抽出する
 *
 * * IDはすべて昇順で配列に格納される
 * * センサーグループの紐付けがないセンサーは `sensorGroupId: null` のレコードに格納される
 * * `sensorGroupId: null` のレコードは配列の末尾に配置される
 *
 * ```
 * [
 *   { sensorGroupId: 1, sensorIds: [1, 2, 3] },
 *   ...,
 *   { sensorGroupId: null, sensorIds: [9] }
 * ]
 * ```
 *
 * @param {Array.<Object>} sensors センサーデータ
 * @returns {Array.<Object>} センサーグループとセンサーの紐付け情報
 */
export const extractSensorGroupSensorRelation = (sensors) => {
  // 1対1で紐づきを収集する
  const relations = []
  for (const { id, sensor_groups } of sensors) {
    if (!sensor_groups.length) {
      relations.push({ sensorGroupId: null, sensorId: id })
      continue
    }
    for (const group of sensor_groups) {
      relations.push({ sensorGroupId: group.sensor_group_id, sensorId: id })
    }
  }

  // グループごとにまとめる
  const result = relations.reduce((accum, { sensorGroupId, sensorId }) => {
    const relation = accum.find((r) => r.sensorGroupId === sensorGroupId)
    if (relation) {
      relation.sensorIds.push(sensorId)
    } else {
      accum.push({ sensorGroupId, sensorIds: [sensorId] })
    }
    return accum
  }, [])

  // ソート
  // センサー
  for (const { sensorIds } of result) {
    sensorIds.sort((a, b) => a - b)
  }
  // センサーグループ
  result.sort((a, b) => {
    // グループ:nullは末尾に移動する
    if (a.sensorGroupId === null) {
      return 1
    } else if (b.sensorGroupId === null) {
      return -1
    } else {
      return a.sensorGroupId - b.sensorGroupId
    }
  })

  return result
}
